module.exports = __webpack_public_path__ + "static/media/img_3.66997b21.png";